export const Regex = {
  stringRegex: /^[A-Za-z\s]+$/,
  numberRegex: /^[0-9]+$/,
  ValidateUrl: /https?:\/\/(?:www\.)?[\w-]+\.[a-z]+(?:\.[a-z]+)?(?:\/\S*)?/i,
  youtubeRegex:
    /^(https?:\/\/)?(www\.)?(youtube\.com\/watch\?v=|youtu\.be\/)[\w-]{11}(&[\w-]+=[\w-]+)*$/,
  englishCharactersRegex: /[a-zA-Z]/,
};
